module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("V91w3"))).then(() => parcelRequire('axfU1'));